import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5eb73590"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  id: "accordionSearchBox",
  class: "accordion accordion-flush pb-50 pb-sm-0 list-unstyled"
}
const _hoisted_3 = { class: "accordion-item" }
const _hoisted_4 = ["id"]
const _hoisted_5 = ["data-bs-target"]
const _hoisted_6 = ["id", "aria-labelledby"]
const _hoisted_7 = { class: "accordion-body px-25 f-14" }
const _hoisted_8 = ["data-value"]
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_checkbox_btn = _resolveComponent("checkbox-btn")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_bt_modal = _resolveComponent("base-bt-modal")!

  return (_openBlock(), _createBlock(_component_base_bt_modal, {
    id: "listing-typology-multiselect-modal",
    "show-modal": _ctx.show,
    "data-cy": "listing-typology-multiselect-modal",
    "custom-modal-header-classes": "d-flex pb-15 px-0",
    "custom-modal-body-classes": "p-0 overflow-auto",
    "custom-modal-footer-classes": "py-10 m-0 fixed-bottom safe-bottom border-0",
    "with-close-icon": true,
    "with-custom-footer": true,
    "full-height": true,
    onClosed: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close-listing-modal')))
  }, {
    header: _withCtx(() => [
      _createElementVNode("h2", {
        class: "f-18",
        innerHTML: _ctx.labels.typology
      }, null, 8 /* PROPS */, _hoisted_1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("ul", _hoisted_2, [
        _createElementVNode("li", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group) => {
            return (_openBlock(), _createElementBlock("ul", {
              key: group.id,
              class: "list-unstyled"
            }, [
              _createElementVNode("li", _hoisted_3, [
                _createElementVNode("p", {
                  id: `heading_${group.url}`,
                  class: "accordion-header"
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["accordion-button px-0 f-14", _ctx.isGroupIdSelected(group.id)? 'fw-semibold' :'collapsed']),
                    type: "button",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": `#collapse_${group.url}`,
                    "aria-expanded": "true",
                    "aria-controls": "collapseOne"
                  }, _toDisplayString(_ctx.decodeTextWithEntities(group.label)), 11 /* TEXT, CLASS, PROPS */, _hoisted_5)
                ], 8 /* PROPS */, _hoisted_4),
                _createElementVNode("div", {
                  id: `collapse_${group.url}`,
                  class: _normalizeClass(["accordion-collapse collapse", _ctx.isGroupIdSelected(group.id)?'show':'']),
                  "aria-labelledby": `heading_${group.url}`,
                  "data-bs-parent": "#accordionSearchBox"
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listingTypologies.filter(o => o.group === group.label), (listingTypology) => {
                      return (_openBlock(), _createBlock(_component_checkbox_btn, {
                        id: 'checkbox_' + listingTypology.id,
                        key: listingTypology.id,
                        class: "d-flex align-items-center",
                        "data-id": 'checkbox_' + listingTypology.id,
                        label: listingTypology.label,
                        "data-cy": group.label +'-'+ listingTypology.label,
                        "container-id": `listing-typology-row-${listingTypology.listingTypologyId}`,
                        "label-class": "w-100",
                        checked: _ctx.isSelected(listingTypology),
                        onChange: ($event: any) => {_ctx.manageListingTypology(_ctx.listingTypologies,listingTypology);}
                      }, null, 8 /* PROPS */, ["id", "data-id", "label", "data-cy", "container-id", "checked", "onChange"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ], 10 /* CLASS, PROPS */, _hoisted_6)
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listingTypologies.filter(lt => !lt.group), (listingTypology) => {
          return (_openBlock(), _createElementBlock("li", {
            key: `${_ctx.name}_menu_${listingTypology.id}`,
            "data-element": "",
            "data-value": listingTypology.id,
            class: _normalizeClass(["ps-0 pointer", _ctx.isSelected(listingTypology)?'active bg-w-cultured fw-semibold':''])
          }, [
            (_openBlock(), _createBlock(_component_checkbox_btn, {
              id: 'checkbox_' + listingTypology.id,
              key: listingTypology.id,
              class: "d-flex align-items-center ps-0 py-15 w-100",
              "container-id": `listing-typology-row-${listingTypology.listingTypologyId}`,
              checked: _ctx.isSelected(listingTypology),
              "input-class": "d-none",
              "wrapper-margin-y": "my-0",
              onChange: ($event: any) => {_ctx.manageListingTypology(_ctx.listingTypologies,listingTypology);}
            }, {
              label: _withCtx(() => [
                _createElementVNode("span", {
                  class: "w-100 f-14",
                  innerHTML: listingTypology.label
                }, null, 8 /* PROPS */, _hoisted_9)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "container-id", "checked", "onChange"]))
          ], 10 /* CLASS, PROPS */, _hoisted_8))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_base_button, {
        "btn-class": "btn-w-primary btn-block",
        onClick: _withModifiers(_ctx.manageConfirm, ["prevent","stop"])
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.labels.confirm), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onClick"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show-modal"]))
}